import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { SubtractCircleIcons } from '../../../../icons/icons';
import { SubSkillsDrawerProps } from '../interfaces';

export const SubSkillsDrawer: React.FC<SubSkillsDrawerProps> = ({
  subSkills,
  onDeleteSubSkill,
}) => {
  return (
    <Box
      sx={{
        mt: 1.5,
        pt: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
        mx: -1.75,
        mb: -1.75,
        p: 1.5,
        borderBottomLeftRadius: '6px',
        borderBottomRightRadius: '6px',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        maxHeight: 192,
        overflowY: 'auto',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5, px: 0.5 }}>
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          Sub-skills ({subSkills.length})
        </Typography>
      </Box>
      {subSkills.map((subSkill) => (
        <Box
          key={subSkill.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 0.75,
            px: 1.25,
            borderRadius: '6px',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            transition: 'border-color 0.15s ease',
            '&:hover': {
              borderColor: 'action.active',
              '& .delete-subskill-btn': {
                opacity: 1,
              },
            },
          }}
        >
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: 'text.primary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              mr: 1,
            }}
            title={subSkill.subskillName}
          >
            {subSkill.subskillName}
          </Typography>
          <IconButton
            className='delete-subskill-btn'
            size='small'
            onClick={() => onDeleteSubSkill(subSkill.id)}
            sx={{
              opacity: 0,
              transition: 'opacity 0.2s ease',
              color: 'error.main',
              p: 0.25,
              borderRadius: '4px',
              flexShrink: 0,
              '&:hover': {
                bgcolor: 'error.lighter',
              },
            }}
            title='Delete sub-skill'
            aria-label={`Delete sub-skill ${subSkill.subskillName}`}
          >
            <SubtractCircleIcons style={{ width: 14, height: 14 }} />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

